<template>
  <v-card>
    <v-card-title>
      Dobrovoľníci ({{ count }})

      <v-spacer/>

      <Create
          :icon="true"
          @init="init"
      />

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          color="default"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          color="default"
          @click="downloadFileByLink(loadLinkByPath('app/volunteers/export'))"
      >
        <v-icon>
          mdi-download
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <v-expansion-panels
              v-model="expansionPanelsFilter"
              :multiple="true"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>
                  <v-icon
                      color="info"
                  >
                    mdi-filter
                  </v-icon>

                  Filtre
                </span>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.name"
                        :error-messages="errors.Filters && errors.Filters.name"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Priezvisko & Meno"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.email"
                        :error-messages="errors.Filters && errors.Filters.email"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="E-mail"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.phone"
                        :error-messages="errors.Filters && errors.Filters.phone"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Telefón"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-card>
            <v-card-text>
              <v-progress-linear
                  v-if="loading"
                  :indeterminate="true"
              />

              <v-simple-table>
                <template
                    v-slot:default
                >
                  <thead>
                    <tr>
                      <th>
                        Fotografia
                      </th>

                      <th
                          class="fixed"
                      >
                        <a
                            @click="setOrder($store.state.register.Volunteer.Filter.order['name'].value)"
                        >
                          <template
                              v-if="params.order === $store.state.register.Volunteer.Filter.order['name'].value"
                          >
                            <template
                                v-if="params.by === $store.state.register.Volunteer.Filter.by['ASC'].value"
                            >
                              <v-icon>
                                mdi-chevron-up
                              </v-icon>
                            </template>

                            <template
                                v-else
                            >
                              <v-icon>
                                mdi-chevron-down
                              </v-icon>
                            </template>
                          </template>

                          Priezvisko & Meno
                        </a>
                      </th>

                      <th>
                        Mesto
                      </th>

                      <th>
                        E-mail
                      </th>

                      <th>
                        Telefón
                      </th>

                      <th>
                        Vek
                      </th>

                      <th
                          class="text-right fixed"
                      />
                    </tr>
                  </thead>

                  <tbody>
                    <template
                        v-if="volunteers.length > 0"
                    >
                      <tr
                          v-for="Volunteer in volunteers"
                          :key="Volunteer.id"
                      >
                        <td>
                          <silent-box
                              v-if="Volunteer.Photo"
                              :image="{
                                  src: loadLinkByPath('files/generate/image/original/' + Volunteer.Photo.token)
                              }"
                          >
                            <template
                                v-slot:silentbox-item
                            >
                              <v-img
                                  :src="loadLinkByPath('files/generate/image/thumbnail/36/36/' + Volunteer.Photo.token)"
                                  alt="Obrázok"
                                  max-width="36px"
                              />
                            </template>
                          </silent-box>

                          <template
                              v-else
                          >
                            <v-icon
                                color="error"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                        </td>

                        <td
                            class="fixed"
                        >
                          <span
                              class="text-truncate"
                              style="max-width: 300px"
                          >
                            {{ Volunteer.name }}
                          </span>

                          <v-badge
                              :inline="true"
                              :value="Volunteer.countApplications"
                              :content="Volunteer.countApplications + 'x'"
                          />
                        </td>

                        <td>
                          <span
                              class="text-truncate"
                              style="max-width: 300px"
                          >
                            {{ Volunteer.city }}
                          </span>
                        </td>

                        <td>
                          <span
                              class="text-truncate"
                              style="max-width: 300px"
                          >
                            {{ Volunteer.email }}
                          </span>
                        </td>

                        <td>
                          <span
                              class="text-truncate"
                              style="max-width: 300px"
                          >
                            {{ Volunteer.phone }}
                          </span>
                        </td>

                        <td>
                          {{ Volunteer.age }}
                        </td>

                        <td
                            class="text-right fixed"
                        >
                          <v-btn
                              :icon="true"
                              :outlined="true"
                              color="primary"
                              :to="'/volunteer/' + Volunteer.id"
                          >
                            <v-icon>
                              mdi-magnify
                            </v-icon>
                          </v-btn>

                          &nbsp;

                          <Update
                              :icon="true"
                              :id="Volunteer.id"
                              @init="init"
                          />

                          &nbsp;

                          <Delete
                              :icon="true"
                              :id="Volunteer.id"
                              @init="init"
                          />
                        </td>
                      </tr>
                    </template>

                    <template
                        v-else
                    >
                      <tr>
                        <td
                            :colspan="7"
                            class="text-center"
                        >
                          Nenašli sa žiadni dobrovoľníci.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row
          v-if="pages !== 0"
          align="center"
      >
        <v-col
            cols="4"
        >
          <a
              v-for="(limit, i) in $store.getters['register/getVolunteerFilterLimit']"
              :key="i"
              @click="setLimit(limit.value)"
          >
            {{ limit.text }}
          </a>
        </v-col>

        <v-spacer/>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === 1 || loading"
              color="primary"
              @click="previousPage"
          >
            <v-icon>
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>

        <v-col
            cols="auto"
        >
          {{ params.page }} / {{ pages }}
        </v-col>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === pages || loading"
              color="primary"
              @click="nextPage"
          >
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import Qs from 'qs'
  import QueryTypes from 'query-types'

  import Volunteers from '@/services/volunteers'

  import Create from '@/components/Volunteers/Create'
  import Update from '@/components/Volunteers/Update'
  import Delete from '@/components/Volunteers/Delete'

  export default {
    name: 'Volunteers',
    components: {
      Create,
      Update,
      Delete
    },
    data() {
      return {
        expansionPanelsFilter: [],
        loading: false,
        count: 0,
        pages: 1,
        volunteers: [],
        params: {
          Filters: {
            name: '',
            email: '',
            phone: ''
          },
          order: this.$store.state.register.Volunteer.Filter.order['name'].value,
          by: this.$store.state.register.Volunteer.Filter.by['ASC'].value,
          limit: this.$store.state.register.Volunteer.Filter.limit[25].value,
          page: 1
        },
        errors: {}
      }
    },
    metaInfo() {
      return {
        title: 'Dobrovoľníci'
      }
    },
    beforeMount() {
      this.beforeInit()
    },
    mounted() {
      this.init()
    },
    methods: {
      beforeInit() {
        this.params = {
          ...this.params,
          ...Qs.parse(QueryTypes.parseObject(this.$route.query))
        }
      },
      init() {
        this.loadData()
      },
      setFilter() {
        this.params.page = 1

        this.init()
      },
      setOrder(order) {
        this.params.order = order

        switch (this.params.by) {
          case this.$store.state.register.Volunteer.Filter.by['ASC'].value:
            this.params.by = this.$store.state.register.Volunteer.Filter.by['DESC'].value

            break

          case this.$store.state.register.Volunteer.Filter.by['DESC'].value:
            this.params.by = this.$store.state.register.Volunteer.Filter.by['ASC'].value

            break
        }

        this.params.page = 1

        this.init()
      },
      setLimit(limit) {
        this.params.limit = limit

        this.params.page = 1

        this.init()
      },
      previousPage() {
        this.params.page -= 1

        window.scrollTo(0, 0)

        this.init()
      },
      nextPage() {
        this.params.page += 1

        window.scrollTo(0, 0)

        this.init()
      },
      setBreadcrumbs() {
        this.$store.dispatch('layout/setBreadcrumbs', {
          breadcrumbs: [
            {
              text: 'Dobrovoľníci',
              to: '/volunteers'
            }
          ]
        })
      },
      loadData() {
        this.setBreadcrumbs()

        this.loading = true

        this.$router.replace('?' + Qs.stringify(this.params))

        Volunteers
          .index({
            params: this.params
          })
          .then((response) => {
            this.count = response.data.data.count

            this.pages = response.data.data.pages

            this.volunteers = response.data.data.volunteers

            this.errors = {}
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      loadLinkByPath(path) {
        return process.env.VUE_APP_AXIOS_URL + path
      },
      downloadFileByLink(link) {
        window.open(link)
      }
    }
  }
</script>
